<template>
    <div class="nPanel-1">
        <!-- 顶部组件 -->
        <n-SearchLsit
            ref="SearchLsit"
            :list="config.searchList"
            :loading="loading"
            @reset="$emit('reset')"
            @search="onSearch"
            @onSearchDataChange="onSearchDataChange"
            @cascadeChange="cascadeChange"
            @visibleChange="visibleChange"
            @changeSecondQueryCondition="changeSecondQueryCondition"
        >
             <template slot="table-module-btn-right">
                 <slot name="table-module-btn-right"></slot>
            </template>
            <div slot="table-module-btn-left">
                <slot name="able-module-btn-left"></slot>
            </div>
            <div slot="table-module-btn-right">
                <slot name="able-module-btn-right"></slot>
            </div>

            <template v-for="item in searchSlotList" v-slot:[item]>
                <slot :name="item"></slot>
            </template>
        </n-SearchLsit>
        <!-- table 组件 -->
        <n-table
            ref="ntable"
            :tableList="config.table"
            :tableData="tableData"
            @onSelectionChange="onSelectionChange"
            @rowDBclick="rowDBclick"
            @rowClick="rowClick"
            @cellClick="cellClick"
            @btn-event="btnEvent"
            @switch-change="switchChange"
            @handleDetail="handleDetail"
            @handleCurrentChange="handleCurrentChange"
            @getTableConfigList="getTableConfigList"
            @handleSortChange="handleSortChange"
            @expandRowKeysChange="expandRowKeysChange"
        >
            <template v-slot:table-expand="props">
                <slot name="table-expand" :props="props.props"></slot>
            </template>
            <template v-for="item in columnSlotList" v-slot:[item]="props">
                <slot :name="item" :props="props.props"></slot>
            </template>
        </n-table>
        <!-- 分页组件 -->
        <el-row type="flex" class="row-bg" justify="space-between">
            <el-col :span="12" class="page-text">
                <div v-if="config.table.selectBtn">
                    {{
                        $translate('lang.E3202102230003', {
                            defaultText: '已选'
                        })
                    }}
                    <span class="text-color"
                        >&nbsp;&nbsp;{{ checkedNum }}&nbsp;&nbsp;</span
                    >
                    {{
                        $translate('lang.E3202101270008', { defaultText: '项' })
                    }}
                </div>
                <slot name="page-module-btn"></slot>
            </el-col>
            <!-- TODO 把分页功能集成在页面内 -->
            <el-col :span="12">
                <el-pagination
                    v-if="config.showPage"
                    background
                    class="table-pagination"
                    :total="pageTotal"
                    :pager-count="5"
                    :page-sizes="config.page.pageSizes || []"
                    :layout="config.page.layout"
                    :page-size="config.page.pageSize"
                    :current-page="config.page.pageNo"
                    @size-change="sizeChange"
                    @current-change="pageChange"
                >
                </el-pagination>
            </el-col>
        </el-row>
    </div>
</template>
<script>
import nSearchLsit from './nSearchLsit.vue';
import nTable from './nTable.vue';
// import nPage from './mPage/Main';
export default {
    components: { nSearchLsit, nTable },
    props: {
        config: {
            type: Object,
            default() {
                return {};
            }
        },
        pageTotal: {
            type: Number,
            default() {
                return 0;
            }
        },
        tableData: {
            type: Array,
            default() {
                return [];
            }
        }
    },
    data() {
        return {
            loading: false,
            checkedNum: 0
        };
    },
    computed: {
        searchSlotList() {
            const slotList = [];
            if (this.config.searchList && this.config.searchList.searchTxt) {
                const list = this.config.searchList.searchTxt;
                list.forEach((item) => {
                    if (item.type === 'category') {
                        slotList.push(`search-${item.value}`);
                    }
                });
            }
            return slotList;
        },
        columnSlotList() {
            const slotList = [];
            if (this.config.table && this.config.table.columns) {
                const list = this.config.table.columns;
                list.forEach((item) => {
                    if (item.type === 'category') {
                        slotList.push(`column-${item.prop}`);
                    }
                });
            }
            return slotList;
        }
    },
    mounted() {},
    methods: {
        // 展开收起需要改变外层高度
        changeSecondQueryCondition(flag) {
            this.$emit('changeSecondQueryCondition', flag);
        },
        expandRowKeysChange(row, key) {
            this.$emit('expandRowKeysChange', row, key);
        },
        // 数据选中回显
        handleSelection(selection) {
            this.$refs.ntable.handleSelection(selection);
        },
        // 重置搜索框
        restSearchForm() {
            this.$refs.SearchLsit.reset();
        },
        // 设置搜索框的值
        setSeachFormValue(key, value) {
            this.$refs.SearchLsit.setSearchData(key, value);
        },
        // 搜索栏值更改
        onSearchDataChange(data) {
            this.$emit('onSearchDataChange', data);
        },
        // 点击搜索事件
        onSearch(data) {
            this.$emit('search', data);
        },

        getTableConfigList(data) {
            this.$emit('getTableConfigList', data);
        },
        cascadeChange(val, data) {
            this.$emit('cascadeChange', val, data);
        },
        visibleChange(val, data) {
            this.$emit('visibleChange', val, data);
        },
        pageChange(pageNo) {
            this.$emit('pageChange', pageNo);
        },
        sizeChange(pageSize) {
            this.$emit('sizeChange', pageSize);
        },
        onSelectionChange(data) {
            this.checkedNum = data.length;
            this.$emit('onSelectionChange', data);
        },
        // 操作
        btnEvent(selection, index, event) {
            this.$emit('btn-event', selection, index, event);
        },
        // 启用停用
        switchChange(data) {
            this.$emit('switch-change', data);
        },
        rowDBclick(data) {
            this.$emit('rowDBclick', data);
        },
        rowClick(row, column) {
            this.$emit('rowClick', row);
        },
        cellClick(data) {
            this.$emit('cellClick', data);
        },
        handleDetail(data) {
            this.$emit('handleDetail', data);
        },
        handleCurrentChange(data) {
            this.$emit('handleCurrentChange', data);
        },
        handleSortChange(data) {
            this.$emit('handleSortChange', data);
        }
    }
};
</script>
<style lang="less">
.nPanel-1 {
    .margin-bottom-20 {
        margin-bottom: 20px;
    }

    .margin-bottom-10 {
        margin-bottom: 10px;
    }
    .m-table-wrapper {
        border: 0;
    }

    .m-table:after {
        width: 0;
    }

    .m-table:before {
        height: 0;
    }

    .m-table td,
    .m-table th {
        border-bottom: 0;
    }

    .zk-table {
        border: 0;
    }

    .zk-table__body,
    .zk-table__footer,
    .zk-table__header {
        border-collapse: initial;
    }
    .page-text {
        display: flex;
        > div {
            height: 28px;
            line-height: 28px;
            font-size: 12px;
            margin-right: 10px;
            .text-color {
                color: #4285f5;
            }
        }
    }

    .btn-box {
        display: flex;
        justify-content: flex-end;
    }
    .row-bg {
        margin-top: 20px;
    }
    .allocation-box {
        margin-left: 10px;
    }
    // .el-table {
    //     height: calc(~'100vh - 180px') !important;
    // }
    .column-config-title small {
        margin-left: 25px;
    }
    .el-table--border {
        border: 1px solid #ebeef5;
    }
    .table-pagination {
        float: right;
        padding: 0;
    }
}
</style>
